'use client';

import { EDatePicker } from '../../DatePicker/type.js';
import { MAX_LENGTH_DATE_INPUT, MAX_LENGTH_YEAR_INPUT, MAX_LENGTH_MONTH_INPUT, REGEXP_YYYY, REGEXP_MMYYYY, REGEXP_DDMMYYYY, FIRST_MONTH, FIRST_DAY } from '../const.js';

var getInputMaxlength = function (type) {
    switch (type) {
        case EDatePicker.date:
            return MAX_LENGTH_DATE_INPUT;
        case EDatePicker.month:
            return MAX_LENGTH_MONTH_INPUT;
        case EDatePicker.year:
            return MAX_LENGTH_YEAR_INPUT;
        default:
            return MAX_LENGTH_DATE_INPUT;
    }
};
var isValidDateFormat = function (value, type) {
    // Regex pattern for dd/mm/yyyy format
    switch (type) {
        case EDatePicker.date:
            return REGEXP_DDMMYYYY.test(value);
        case EDatePicker.month:
            return REGEXP_MMYYYY.test(value);
        case EDatePicker.year:
            return REGEXP_YYYY.test(value);
        default:
            throw new Error('Invalid type. Supported types are "date", "month", and "year".');
    }
};
var padZero = function (value) {
    return value.toString().padStart(2, '0');
};
var formatInputDate = function (value, type, formatTo) {
    var dateParts = value.split('/');
    var date = '';
    var month = '';
    var year = '';
    switch (dateParts.length) {
        case 1:
            year = dateParts[0];
            break;
        case 2:
            month = dateParts[0];
            year = dateParts[1];
            break;
        case 3:
            date = dateParts[0];
            month = dateParts[1];
            year = dateParts[2];
            break;
        default:
            throw new Error('Invalid date format. Supported formats are "dd/mm/yyyy", "mm/yyyy", and "yyyy".');
    }
    // Check if the entered date is a valid date
    var isValidDate = isValidDateFormat(value, type);
    var output = '';
    switch (type) {
        case EDatePicker.date:
            // If the date is valid and not "00/00/0000", format it as "dd/mm/yyyy"
            if (isValidDate && !(date === '00' && month === '00' && year === '0000')) {
                output =
                    formatTo === 'string'
                        ? "".concat(padZero(date), "/").concat(padZero(month), "/").concat(year)
                        : new Date(Number(year), Number(month) - 1, Number(date));
                return output;
            }
            break;
        case EDatePicker.month:
            // If the date is valid and not "00/0000", format it as "mm/yyyy"
            if (isValidDate && !(month === '00' && year === '0000')) {
                output =
                    formatTo === 'string' ? "".concat(padZero(month), "/").concat(year) : new Date(Number(year), Number(month) - 1, 1);
                return output;
            }
            break;
        case EDatePicker.year:
            // If the date is valid and not "0000", format it as "yyyy"
            if (isValidDate && !(year === '0000')) {
                output = formatTo === 'string' ? year : new Date(Number(year), FIRST_MONTH, FIRST_DAY);
                return output;
            }
            break;
        default:
            throw new Error('Invalid type. Supported types are "day", "month", and "year".');
    }
    // If the date is not valid or "00/00/0000", return the empty string
    return '';
};

export { formatInputDate, getInputMaxlength, isValidDateFormat };
//# sourceMappingURL=index.js.map
